module.exports = __webpack_public_path__ + "static/media/logo.af589977.png";